import { Link, useLocation } from "react-router-dom";

/* NAVIGATION DATA */
import { navSections } from "../../data/navigation";

/* ASSETS */
import Logo from "../../assets/images/logo-header.png";

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <section className="h-sidebar w-sidebar bg-[#141518] transition-all duration-300 ease-linear rounded-xl shadow-xl">
      {/* HEADER */}
      <div className="h-header border-b border-white border-opacity-20 px-5 flex items-center">
        <Link to="/orders">
          <img
            src={Logo}
            className="w-20 h-auto object-contain cursor-pointer"
            alt="CIDA PERFUMES"
          />
        </Link>
      </div>

      {/* NAVIGATION OPTIONS */}
      <div className="h-[90vh] flex flex-col justify-between overflow-y-auto hide-scrollbar">
        <div className="p-5">
          {navSections.map((section, sectionIdx) => (
            <div key={section.title} className={sectionIdx === 0 ? "mt-0" : "mt-8"}>
              <h5 className="text-xs font-proxima-semibold text-white text-opacity-50 tracking-wider">
                {section.title}
              </h5>
              {section.items.map((item) => {
                const isActive =
                  !item.disabled &&
                  (pathname === item.link ||
                    (item.link === "/orders" && (pathname === "/orders" || pathname.startsWith("/order/"))));

                if (item.disabled) {
                  return (
                    <div
                      key={item.id}
                      className="w-full flex items-center justify-between first-of-type:mt-5 mt-6 opacity-40 cursor-not-allowed select-none group"
                      title="Coming soon"
                    >
                      <div className="flex items-center gap-3">
                        <item.icon className="w-5 h-5 text-sidebarText" />
                        <p className="text-base font-proxima-semibold text-sidebarText leading-none">
                          {item.name}
                        </p>
                      </div>
                      <span className="text-[10px] font-proxima-semibold bg-white/10 text-white/60 px-2 py-0.5 rounded">
                        Soon
                      </span>
                    </div>
                  );
                }

                return (
                  <Link
                    to={item.link}
                    key={item.id}
                    className="w-full group flex items-center gap-3 first-of-type:mt-5 mt-6"
                  >
                    <item.icon
                      className={`w-5 h-5 text-sidebarText ${
                        isActive && "text-white"
                      } group-hover:text-white transition-all duration-300 ease-in-out`}
                    />
                    <div>
                      <p
                        className={`text-base font-proxima-semibold text-sidebarText ${
                          isActive && "text-white"
                        } group-hover:text-white leading-none transition-all duration-300 ease-in-out`}
                      >
                        {item.name}
                      </p>
                    </div>
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
